/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PointOfInterest } from '../models/PointOfInterest';
import type { Polygons } from '../models/Polygons';
import type { University } from '../models/University';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PointsOfInterestService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Find points of interest within a given radius from a coordinate.
     * @param latitude Latitude of the center point
     * @param longitude Longitude of the center point
     * @param radiusMiles Radius in miles to search within
     * @param id
     * @returns PointOfInterest Array of points of interest within the radius
     * @throws ApiError
     */
    public pointsOfInterest(
        latitude: number,
        longitude: number,
        radiusMiles: number,
        id: string,
    ): CancelablePromise<Array<PointOfInterest>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/poi/points_of_interest',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'radiusMiles': radiusMiles,
                'id': id,
            },
        });
    }
    /**
     * Find points of interest within a multipolygon area.
     * @param requestBody Object containing coordinates for the multipolygon
     * @returns PointOfInterest Array of points of interest within the polygon
     * @throws ApiError
     */
    public pointsOfInterestByPolygon(
        requestBody: {
            coordinates: Polygons;
        },
    ): CancelablePromise<Array<PointOfInterest>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/poi/points_of_interest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Find universities within a given radius from a coordinate.
     * @param latitude Latitude of the center point
     * @param longitude Longitude of the center point
     * @param radiusMiles Radius in miles to search within
     * @param id
     * @returns University Array of universities within the radius
     * @throws ApiError
     */
    public universities(
        latitude: number,
        longitude: number,
        radiusMiles: number,
        id: string,
    ): CancelablePromise<Array<University>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/poi/universities',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'radiusMiles': radiusMiles,
                'id': id,
            },
        });
    }
    /**
     * Find universities within a multipolygon area.
     * @param requestBody Object containing coordinates for the multipolygon
     * @returns University Array of universities within the polygon
     * @throws ApiError
     */
    public universitiesByPolygon(
        requestBody: {
            coordinates: Polygons;
        },
    ): CancelablePromise<Array<University>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/poi/universities',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
